import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSun = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_271_5356)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12 17.5C15.0376 17.5 17.5 15.0376 17.5 12C17.5 8.96243 15.0376 6.5 12 6.5C8.96243 6.5 6.5 8.96243 6.5 12C6.5 15.0376 8.96243 17.5 12 17.5ZM12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19Z",
				fill: "var(--colors-grey-1)"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M24 12C24 12.4142 23.6642 12.75 23.25 12.75L20.75 12.75C20.3358 12.75 20 12.4142 20 12C20 11.5858 20.3358 11.25 20.75 11.25L23.25 11.25C23.6642 11.25 24 11.5858 24 12ZM4 12C4 12.4142 3.66421 12.75 3.25 12.75H0.75C0.335787 12.75 -1.81059e-08 12.4142 0 12C1.81058e-08 11.5858 0.335787 11.25 0.75 11.25H3.25C3.66421 11.25 4 11.5858 4 12Z",
				fill: "var(--colors-grey-1)"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M20.4852 3.51484C20.7781 3.80773 20.7781 4.2826 20.4852 4.5755L18.7174 6.34326C18.4245 6.63616 17.9496 6.63616 17.6567 6.34326C17.3638 6.05037 17.3638 5.57549 17.6567 5.2826L19.4245 3.51484C19.7174 3.22194 20.1923 3.22194 20.4852 3.51484ZM6.34303 17.657C6.63592 17.9499 6.63592 18.4247 6.34303 18.7176L4.57526 20.4854C4.28237 20.7783 3.8075 20.7783 3.5146 20.4854C3.22171 20.1925 3.22171 19.7176 3.5146 19.4247L5.28237 17.657C5.57526 17.3641 6.05014 17.3641 6.34303 17.657Z",
				fill: "var(--colors-grey-1)"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12 0C12.4142 1.78814e-07 12.75 0.335787 12.75 0.75L12.75 3.25C12.75 3.66421 12.4142 4 12 4C11.5858 4 11.25 3.66421 11.25 3.25L11.25 0.75C11.25 0.335786 11.5858 -1.78814e-07 12 0ZM12 20C12.4142 20 12.75 20.3358 12.75 20.75V23.25C12.75 23.6642 12.4142 24 12 24C11.5858 24 11.25 23.6642 11.25 23.25V20.75C11.25 20.3358 11.5858 20 12 20Z",
				fill: "var(--colors-grey-1)"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M3.51484 3.51484C3.80773 3.22194 4.2826 3.22194 4.5755 3.51484L6.34326 5.2826C6.63616 5.5755 6.63616 6.05037 6.34326 6.34326C6.05037 6.63616 5.57549 6.63616 5.2826 6.34326L3.51484 4.5755C3.22194 4.2826 3.22194 3.80773 3.51484 3.51484ZM17.657 17.657C17.9499 17.3641 18.4247 17.3641 18.7176 17.657L20.4854 19.4247C20.7783 19.7176 20.7783 20.1925 20.4854 20.4854C20.1925 20.7783 19.7176 20.7783 19.4247 20.4854L17.657 18.7176C17.3641 18.4247 17.3641 17.9499 17.657 17.657Z",
				fill: "var(--colors-grey-1)"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_271_5356",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgSun;
